import { PLACE_OF_SERVICE_CODES } from '../types';

/**
 * The CMS place-of-service table, shaped for a picker (GDN-3344).
 *
 * Extracted from `components/Claim/PlaceOfServiceSelect.tsx`, which owned it
 * privately, so the claim workbench's grouped Select can offer the SAME
 * codes in the SAME order without importing an Autocomplete it does not
 * want. Pure data and pure ordering: no component, no MUI, nothing to mock.
 */

export type PlaceOfServiceOption = {
  code: string;
  name: string;
  isCommon: boolean;
};

/** Most commonly used POS codes, pinned to the top of the list in this order. */
export const COMMON_POS_CODES: readonly string[] = ['02', '10', '11', '12', '21'];

/** Common codes first (in COMMON_POS_CODES order), then everything else by code. */
export const PLACE_OF_SERVICE_OPTIONS: readonly PlaceOfServiceOption[] = (() => {
  const entries = Object.entries(PLACE_OF_SERVICE_CODES);

  const common = entries
    .filter(([code]) => COMMON_POS_CODES.includes(code))
    .sort((a, b) => COMMON_POS_CODES.indexOf(a[0]) - COMMON_POS_CODES.indexOf(b[0]))
    .map(([code, name]) => ({ code, name, isCommon: true }));

  const others = entries
    .filter(([code]) => !COMMON_POS_CODES.includes(code))
    .sort((a, b) => a[0].localeCompare(b[0]))
    .map(([code, name]) => ({ code, name, isCommon: false }));

  return [...common, ...others];
})();
